import React from 'react';
import { IconPencil } from '@paretogroup/tess';
import {
    CLUSTER_SELECTOR_CAMPAIGNS_TEXTS,
} from '@domain/budget-manager/modal/table/components/cluster-selector/cluster-selector.constants';
import { TEST_IDS } from './edit-name-field.constants';
import * as S from './cluster-name-field.styles';

interface EditNameFieldProps {
    editing: boolean;
    enableFieldEdition: () => void,
    handleFormSubmit: (e: React.FormEvent<HTMLFormElement>) => void,
    handleChangeValue: (target: string) => void,
    handleValueInputted: () => void,
    handleKeyUp: (ev: Object) => void,
    fieldValue: string,
    inputRef: React.MutableRefObject<any>
}

export const ClusterNameFieldWrapper = ({
    editing,
    enableFieldEdition,
    handleFormSubmit,
    handleChangeValue,
    handleValueInputted,
    handleKeyUp,
    fieldValue,
    inputRef,
}: EditNameFieldProps) => {
    const isFieldValueUntagged = fieldValue
     === CLUSTER_SELECTOR_CAMPAIGNS_TEXTS.CAMPAIGN_NOT_CLUSTERED.toLowerCase();

    return (
        <S.EditButtonWrapper
            onClick={!isFieldValueUntagged ? enableFieldEdition : null}
            editing={editing}
            data-testid={TEST_IDS.CLUSTER_DIV}
        >
            <form onSubmit={handleFormSubmit} data-testid={TEST_IDS.CLUSTER_FORM}>
                <input
                    type="text"
                    ref={inputRef}
                    value={fieldValue}
                    data-testid={TEST_IDS.EDIT_NAME_FIELD}
                    disabled={!editing}
                    onChange={event => handleChangeValue(event.target.value)}
                    onBlur={handleValueInputted}
                    onKeyUp={handleKeyUp}
                    maxLength={50}
                />
            </form>
            {!isFieldValueUntagged ? (
                <S.EditIconWrapper
                    visible={!editing}
                >
                    <IconPencil
                        dataTestId={TEST_IDS.ICON_PENCIL}
                        size={16}
                    />
                </S.EditIconWrapper>
            ) : <></>}
        </S.EditButtonWrapper>
    );
};
